import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type FoundationSectionProps = {
  content: PillarPageContent['foundation'];
};
export function FoundationSection({
  content
}: FoundationSectionProps) {
  return <section className="relative w-full overflow-hidden bg-ink py-28 lg:py-40" data-id="element-93" data-mp="2136r31v4321y">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-accent/[0.05] blur-[140px]" aria-hidden="true" data-id="element-94" data-mp="2xsxwhw4xy9mj" />

      <div className="relative mx-auto w-full max-w-[1240px] px-6 sm:px-10" data-id="element-95" data-mp="2sw7aks6ggjt7">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12 lg:gap-20" data-id="element-96" data-mp="2o1bhrpte9sf1">
          <Reveal className="lg:order-2 lg:col-span-5" data-id="element-97" data-mp="2k1173zunqdtu">
            <figure className="overflow-hidden rounded-3xl border border-accent-deep/70" data-id="element-98" data-mp="3gjyxsqtjah99">
              <img src={content.image} alt={content.imageAlt} className="h-[320px] w-full object-cover opacity-85 lg:h-[440px]" data-id="element-99" data-mp="3bsyw789gzb0f" />
            </figure>
          </Reveal>

          <div className="lg:order-1 lg:col-span-7" data-id="element-100" data-mp="22b76d0ezrm0g">
            <Reveal data-id="element-101" data-mp="1nnm396i49msj">
              <Eyebrow data-id="element-102" data-mp="1no5kekzy075i">{content.eyebrow}</Eyebrow>
              <h2 className="mt-6 max-w-xl text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3rem]" data-id="element-103" data-mp="1nncflpkjnrq0">
                {content.title}
              </h2>
            </Reveal>

            <Reveal delay={0.06} data-id="element-104" data-mp="1epai3k00rh7h">
              <blockquote className="mt-11 rounded-3xl border border-accent-deep/70 bg-surface p-8 lg:p-10" data-id="element-105" data-mp="1jmk5yv7rfkt7">
                <p className="text-lg font-semibold leading-snug text-bone sm:text-xl" data-id="element-106" data-mp="14pji52sowa00">
                  {content.quote}
                </p>
                <footer className="mt-5 text-[11px] font-semibold uppercase tracking-label text-accent" data-id="element-107" data-mp="19pxjy33p6npl">
                  {content.quoteSource}
                </footer>
              </blockquote>
            </Reveal>

            <Reveal delay={0.1} data-id="element-108" data-mp="32kp1swl5mp9d">
              <div className="mt-10 max-w-xl space-y-5 text-[15px] leading-relaxed text-ash sm:text-base" data-id="element-109" data-mp="32kys6la42yfl">
                <p data-id="element-110" data-mp="2xkkhswl1fcee">{content.lead}</p>
                <p className="text-bone" data-id="element-111" data-mp="2xnoukickjggo">{content.closing}</p>
              </div>
            </Reveal>
          </div>
        </div>

        <ul className="mt-20 grid grid-cols-1 gap-5 sm:grid-cols-3" data-id="element-112" data-mp="2ol76rzh9mfrk">
          {content.virtues.map((virtue, i) => {
          const Icon = virtue.icon;
          return <Reveal as="li" key={virtue.label} delay={0.05 * i} className="h-full" data-id="element-113" data-mp="3ld10988ot6e8" data-mpi={i}>
                <article className="flex h-full flex-col rounded-3xl border border-accent-deep/60 bg-surface p-8 transition-[border-color,transform] duration-200 ease-elite hover:-translate-y-1 hover:border-accent/40" data-id="element-114" data-mp="3ge6kkf60nxyc">
                  <Icon className="h-5 w-5 text-accent" strokeWidth={1.5} aria-hidden="true" data-id="element-115" data-mp="7wa34l8zv8xs" />
                  <h3 className="mt-7 text-[11px] font-bold uppercase tracking-label text-bone" data-id="element-116" data-mp="7y4o1zk9n11v">
                    {virtue.label}
                  </h3>
                  <p className="mt-4 text-[15px] leading-relaxed text-ash" data-id="element-117" data-mp="1ltmu3oeujqn2">{virtue.text}</p>
                </article>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}